import React, { Component } from 'react';
import Siteheader from '../common/layout/siteheader'; 
import Footer from '../common/layout/footer';
import Loader from '../common/loader';

import { Link, Navigate } from "react-router-dom";

import Cartitem1 from '../assets/images/pcart-item-1.jpg';
import Cartitem2 from '../assets/images/pcart-item-2.jpg';
import Cartitem3 from '../assets/images/pcart-item-3.jpg';
import Cartitem4 from '../assets/images/pcart-item-4.jpg';
import maintainIcon from '../assets/images/gear-maintanance.png';



class Sitemaintanence extends Component {

    constructor(props) {
        super(props);
        this.state = {
          caegories:[],
          loading: true,
        };

        if(localStorage.getItem("sitemaintanance") == '0'){
            window.location.href = '/';
         }
    }

    componentDidMount(){

        var timeInterval = '1000';
        this.setState({loading: true});

        var current = this;
        var myInterval = setInterval(function() {
            timeInterval = '';
            current.setState({loading: false});
            clearInterval(myInterval);
          },timeInterval);

    }

    render(){

        return(
            <>
                <div className='site-maintanance-page'>
                <Siteheader/>
                    {!this.state.loading &&
                    <main className='main-section'>
                    <section className="cart-block">

                        <div className="sm-container">
                        
                           <div className='site-maintanance-wrap'>
                                <div className='maintanance-icon'>
                                    <img src={maintainIcon} className="set-icon" alt="Site Maintanance" />
                                </div>
                                <p><span>We're currently offline,</span>Please contact our customer service team on <a href="tel:01295367351">01295 367351</a></p>
                            </div>

                            <div className="cart-flx">
                                <div className="cart-item">
                                    <a className="cart-innr">
                                        <div className="cart-top">
                                            <p>PIZZA</p>
                                        </div>
                                        <img src={Cartitem1} className="cart-back" alt="Cart" />
                                    </a>
                                </div>
                                <div className="cart-item">
                                <a className="cart-innr">
                                        <div className="cart-top">
                                            <p>PASTA, RICE & NOODLE SAUCES</p>
                                        </div>
                                        <img src={Cartitem2} className="cart-back" alt="Cart" />
                                    </a>
                                </div>
                                <div className="cart-item">
                                <a className="cart-innr">
                                        <div className="cart-top">
                                            <p>BURRITO</p>
                                        </div>
                                        <img src={Cartitem3} className="cart-back" alt="Cart" />
                                    </a>
                                </div>
                                <div className="cart-item">
                                    <Link className="cart-innr" to="/categories">
                                        <div className="cart-top">
                                            <p>PRODUCTS INFO</p>
                                        </div>
                                          <div className="cart-bottom">
                                            <p>
                                                NUTRITIONAL / ALLERGEN INFO & PREP GUIDES
                                            </p>
                                        </div>
                                        <img src={Cartitem4} className="cart-back" alt="Cart" />
                                    </Link>
                                </div>
                            </div>

         
                            
                        </div>
                    </section>
                    </main>


                   }

                    {/* Loader & Popup START */}
                    <div className="common">
                        
                        {/* <Alert extractId="success" customContent="Cart Added Success" /> */}

                    </div>

                    {this.state.loading && <main className='main-section'><Loader propsClassName="load-lag" /> </main>}

                    {/* Loader & Poupp END */}

                            <Footer/>
                </div>
            </>
        );
    }
}

export default Sitemaintanence;